import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";

import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from "@mui/material";

import {App} from './App';
import {muiStandardTheme} from "./qdep/components/theme/mui";
import {persistor, store} from "./app/state/store";

import './index.css';
import {SnackbarProvider} from "notistack";


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <ThemeProvider theme={muiStandardTheme}>
                    <SnackbarProvider
                        maxSnack={3}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        classes={{
                            variantError: "notification-container"
                        }}
                    >
                        <App/>
                    </SnackbarProvider>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
